(function ClientTravelDeals($, Adzuki, tinymce)
{
	"use strict";

	function reloadPreview(changes) {
		var preview_url = '/Sources/confirmationEmailPreview';

		Adzuki.Ajax.post(preview_url, changes).then(function success(response) {
			$("#optin_confirmation_email_preview").html(response);
		});
	}

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Sources/editConfirmationEmail/', function onload()
		{

			var form            = $("#optin_confirmation_form"),
				$modal          = $('.modal'),
				background      = form.find("#optinconfirmationemail-postcard_optin_background_id"),
				header_text     = form.find("#optinconfirmationemail-header_text"),
				header_text_size= form.find("#optinconfirmationemail-header_text_size"),
				body_text       = '',
				changes         = {
					background      : background.val(),
					header_text     : header_text.val(),
					header_text_size: header_text_size.val(),
					body_text       : body_text,
				};

			Adzuki.Editor('#optinconfirmationemail-body_text', {
				init_instance_callback: function onEditorInit(editor)
				{
					body_text         = editor.getContent();
					changes.body_text = body_text;
					reloadPreview(changes);
				},
				setup: function onEditorChange(editor)
				{
					editor.on('change', function updateBodyText()
					{
						changes.body_text = editor.getContent();
						$('#optinconfirmationemail-body_text').html(changes.body_text);
						reloadPreview(changes);
					});
				}
			});

			// background theme
			background.on('change', function updateChanges()
			{
				var change             = $(this);
				    changes.background = change.val();
				reloadPreview(changes);
			});

			// visual list click
			$modal.on('click', '.visual-list-container .select-image', function loadPreview()
			{
				var change         = $(this),
				    visual_list_id = change.data("id"),
				    img_preview    = change.data("src");

				changes.background = visual_list_id;
				$(".thumbnail").attr('src', img_preview);
				reloadPreview(changes);
			});

			// header text
			header_text.on('change', function updateChanges()
			{
				var change              = $(this);
				    changes.header_text = change.val();
				reloadPreview(changes);
			});

			// header text size
			header_text_size.on('change', function updateChanges()
			{
				var change                   = $(this);
				    changes.header_text_size = change.val();
				reloadPreview(changes);
			});

			if ($(".visual-list-selector option:selected").data('url').length > 0) {
				$(".thumbnail").attr("src", $(".visual-list-selector option:selected").data('url'));
				$(".thumbnail").removeClass("hidden");
			}

			// onload, load up preview
			reloadPreview(changes);
		});

		Adzuki.onload('/Sources/addConfirmationEmail/', function onload()
		{

			var form            = $("#optin_confirmation_form"),
			    $modal          = $('.modal'),
				background      = form.find("#optinconfirmationemail-postcard_optin_background_id"),
				header_text     = form.find("#optinconfirmationemail-header_text"),
				header_text_size= form.find("#optinconfirmationemail-header_text_size"),
				body_text       = '',
				changes         = {
					background      : background.val(),
					header_text     : header_text.val(),
					header_text_size: header_text_size.val(),
					body_text       : body_text,
				};

			Adzuki.Editor('#optinconfirmationemail-body_text', {
				// init_instance_callback: function onEditorInit(editor)
				// {
				// 	body_text         = editor.getContent();
				// 	changes.body_text = body_text;
				// 	reloadPreview
				// },
				setup: function onEditorChange(editor)
				{
					editor.on('change', function updateBodyText()
					{
						changes.body_text = editor.getContent();
						$('#optinconfirmationemail-body_text').html(changes.body_text);
						reloadPreview(changes);
					});
				}
			});

			// background theme
			background.on('change', function updateChanges()
			{
				var change             = $(this);
				    changes.background = change.val();
				reloadPreview(changes);
			});

			// visual list click
			$modal.on('click', '.visual-list-container .select-image', function loadPreview()
			{
				var change         = $(this),
				    visual_list_id = change.data("id"),
				    img_preview    = change.data("src");

				changes.background = visual_list_id;
				$(".thumbnail").attr('src', img_preview);
				reloadPreview(changes);
			});

			// header text
			header_text.on('change', function updateChanges()
			{
				var change              = $(this);
				    changes.header_text = change.val();
				reloadPreview(changes);
			});

			// header text size
			header_text_size.on('change', function updateChanges()
			{
				var change                   = $(this);
				    changes.header_text_size = change.val();
				reloadPreview(changes);
			});

			// onload, load up preview
			reloadPreview(changes);
		});
	});

}(jQuery, window.Adzuki || {}, window.tinymce || {}));
